import { Label } from 'components/atoms';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PiCheckCircleBold, PiCircleBold } from 'react-icons/pi';
import { ACTIVE_STATUS } from 'services/types';
import { IColorProp } from 'types/components/components.interface';

export interface ILabeledStatusProps {
  status: ACTIVE_STATUS;
}

interface ILabeledStatusParams extends IColorProp {
  status: ACTIVE_STATUS;
  icon: ReactNode;
}

const labeledStatusParams: ILabeledStatusParams[] = [
  {
    status: ACTIVE_STATUS.Inactive,
    color: 'red',
    icon: <PiCircleBold />,
  },
  {
    status: ACTIVE_STATUS.Active,
    color: 'blue',
    icon: <PiCheckCircleBold />,
  },
];

const LabeledActiveStatus = ({ status }: ILabeledStatusProps) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledStatusParams.find(params => params.status === status) ??
    labeledStatusParams[0];
  return (
    <Label
      size='compact'
      color={labeledParams.color}
      title={t(`${labeledParams.status}`)}>
      {labeledParams.icon} {t(`enum.ACTIVE_STATUS.${ACTIVE_STATUS[labeledParams.status]}`)}
    </Label>
  );
};

export default LabeledActiveStatus;
